import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import MobileTimesheetAccordion from "../components/MobileTimesheetAccordion";
import PageLayout from "../components/PageLayout";
import TimesheetTable from "../components/TimesheetTable";
import { usePageTracking } from "../hooks/usePageTracking";

interface Props {}

const History: FunctionComponent<Props> = (props: Props): JSX.Element => {
  usePageTracking();
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <PageLayout header={t("history.title")}>
      {isSmallScreen || isMediumScreen ? (
        <>
          <MobileTimesheetAccordion type="history" />
          {isMediumScreen && !isSmallScreen && (
            <Typography variant="body2" sx={{ pt: "20px" }}>
              * {t("timesheets.weekEndingText")}
            </Typography>
          )}
        </>
      ) : (
        <>
          <TimesheetTable
            type="history"
            onTimeSheetAmend={() => null}
            isEnabled={true}
          />
          <Typography variant="body2" sx={{ pt: "20px" }}>
            {" "}
            * {t("timesheets.weekEndingText")}
          </Typography>
        </>
      )}
    </PageLayout>
  );
};

export default History;
